var _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoAmarela(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 34.9311,
    cy: 35,
    r: 34.9311,
    fill: "#FF9900"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.6038 47.4045L47.3038 22.7045M47.3038 22.7045L47.3407 33.703M47.3038 22.7045L36.3053 22.6676",
    stroke: "white",
    strokeWidth: 1.77567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5634 47.6783L41.2667 36.975",
    stroke: "white",
    strokeWidth: 1.77567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3301 39.4448L32.9865 28.6947",
    stroke: "white",
    strokeWidth: 1.77567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4615 31.9896L25.5782 27.873",
    stroke: "white",
    strokeWidth: 1.77567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9734 48.5016L42.0901 44.3849",
    stroke: "white",
    strokeWidth: 1.77567,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoAmarela);
export default __webpack_public_path__ + "static/media/logo-amarela.5eb1627d44e1ac7f2fc3ad5d251f04aa.svg";
export { ForwardRef as ReactComponent };